<template>
    <div class="moduleIndex main-content" :style="mainContentViewHeight" v-loading.lock="fullscreenLoading">
        <div class="searchTop">
            关键字：
            <el-input v-model="searchKey"></el-input>
            <el-button @click="searchData">查询</el-button>
            <el-button @click="refreshData">刷新</el-button>
            <el-button @click="addData">新增</el-button>
            <el-button type="primary" @click="clearAll">清除缓存</el-button>
        </div>
        <div class="tableBox">
            <el-table
                border
                :data="tableData"
                :header-row-style="{backgroundColor:'#f7f7f7'}"
                :header-cell-class-name="cellName"
                stripe
                style="width: 100%">
                <el-table-column
                    type="index"
                    label="序号"
                    width="50">
                </el-table-column>
                <el-table-column
                    label="操作"
                    width="180">
                    <template slot-scope="scope">
                        <div class="opt">
                            <div class="btn btnBlue" @click="openData(scope.row.id)">查看</div>
                            <div class="btn btnBlue" @click="showRouteConfig(scope.row.id)">配置</div>
                            <div class="btn btnBlue" @click="deleteData(scope.row.id)">删除</div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="name"
                    label="模块名称"

                    width="150">
                </el-table-column>
                <el-table-column
                    prop="code"
                    min-width="300"
                    label="模块编号">
                </el-table-column>
                <el-table-column
                    prop="appId"
                    min-width="300"
                    label="APPID">
                    <template slot-scope="scope">
                        {{ scope.row.proxyEnabled == true ? '无' : scope.row.appId }}
                    </template>
                </el-table-column>
                <el-table-column v-if="false"
                                 prop="version"
                                 width="150"
                                 label="模块版本">
                </el-table-column>
                <el-table-column
                    prop="proxyEnabled"
                    width="130"
                    label="模块类型">
                    <template slot-scope="scope">
                        {{ scope.row.proxyEnabled == true ? '3.0业务模块' : '5.0业务模块' }}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="menuParentId"
                    min-width="150"
                    label="业务菜单">
                </el-table-column>
                <el-table-column
                    prop="settingParentId"
                    min-width="150"
                    label="系统设置菜单">
                </el-table-column>
                <el-table-column
                    prop="status"
                    width="150"
                    label="状态">
                    <template slot-scope="scope">
                        {{ scope.row.status == 0 ? '未发布' : '已发布' }}
                    </template>
                </el-table-column>
            </el-table>
            <div>
                <paginationCom @sizechange="sizeChangeHandle" @pagechange="pageChangeHandle" class="limit"
                               :options="paginationOpt"></paginationCom>
            </div>
        </div>
    </div>
</template>
<script>
import paginationCom from '../components/pagination';
import {modulePaged, moduleDelete, moduleClearAll} from '../server/module'

export default {
    props: ["mainContentViewHeight"],
    data() {
        return {
            tableData: [{name: '111'}, {name: '222'}, {name: '333'}, {name: '444'}, {name: '555'}, {name: '666'}],
            searchKey: '',
            fullscreenLoading: false,//表格laoding
            paginationOpt: {
                pageIndex: 1,
                pageSize: 10,
                total: 1,
                pageSizes: [10, 20, 50]
            },
        }
    },
    components: {
        paginationCom
    },
    methods: {
        cellName() {
            return 'cellName'
        },
        // 每页长度改变
        sizeChangeHandle(value) {
            this.paginationOpt.pageSize = value;
            this.paginationOpt.pageIndex = 1;
            this.getData();
        },
        // 当前页改变
        pageChangeHandle(value) {
            this.paginationOpt.pageIndex = value;
            this.getData();
        },
        getData(callback) {//获取列表信息
            this.fullscreenLoading = true;
            var data = {
                page: this.paginationOpt.pageIndex,
                rows: this.paginationOpt.pageSize,
                searchKey: this.searchKey,
            }
            modulePaged(this.$http, data).then(res => {
                if (res.data.code) {
                    this.$message.error(res.data.msg)
                } else {
                    this.tableData = res.data.rows;
                    this.paginationOpt.total = res.data.total;
                    callback && callback()
                }
            }).finally(() => {
                this.fullscreenLoading = false;
            })
        },
        openData(id) {//查看详情
            console.log(id)
            this.$router.push({path: `/moduleAdd/${id}`, params: {id: id}})
        },
        showRouteConfig(id) {
            this.$router.push({path: `/moduleRouteConfig/${id}`, params: {id: id}})
        },
        refreshData() {//刷新列表
            this.paginationOpt.pageIndex = 1;
            this.getData(()=>{
                this.$message.success('刷新成功')
            });
        },
        searchData() {//模糊查询列表
            this.paginationOpt.pageIndex = 1;
            this.getData();
        },
        addData() {//新增数据
            this.$router.push({path: `/moduleAdd/0`})
        },
        deleteData(id) {//删除列表数据

            this.$alert('是否删除', '删除', {
                confirmButtonText: '确定',
                callback: action => {
                    if (action === 'confirm') {
                        this.fullscreenLoading = true;
                        moduleDelete(this.$http, {id: id}).then(res => {
                            if (res.data.code == 1) {
                                this.$message.success(res.data.msg)
                                this.getData();
                            } else {
                                this.$message.error(res.data.msg)
                            }
                        }).finally(() => {
                            this.fullscreenLoading = false;
                        })
                    }
                }
            });

        },
        clearAll() {//清除所有缓存
            this.fullscreenLoading = true;
            moduleClearAll(this.$http).then(res => {
                if (res.data.code == 1) {
                    this.$message.success(res.data.msg)
                } else {
                    this.$message.error(res.data.msg)
                }
            }).finally(() => {
                this.fullscreenLoading = false;
            })
        }

    },
    activated() {
        this.getData();
    }
}
</script>
<style lang="scss">
.moduleIndex {
    overflow: hidden;
    padding: 15px;

    .searchTop {
        margin-top: 20px;
        text-align: right;

        .el-input {
            width: 200px;
            margin-right: 10px;
        }
    }

    .tableBox {
        margin: 20px 0px 0px 0px !important;

        .opt {
            display: flex;
            justify-content: center;

            div {
                margin: 0 10px;
                color: #17b3a3;
                cursor: pointer;
            }
        }

        /deep/ .el-table__row > td, /deep/ .el-table__header th, .el-table {
            border-color: #c0c0c0;
        }

        /deep/ .el-table {
            border-right: 1px solid #c0c0c0;
        }
    }
}

.el-button {
    padding: 6px 12px 6px;
}

.el-button:hover {
    color: #333333;
    background-color: #e6e6e6;
    border-color: rgba($color: #000000, $alpha: 0.1);
}

.cellName {
    text-align: center !important;
    background-color: #f8f8f8 !important;
    font-weight: bold !important;
    color: #333;
}

/deep/ .el-input__inner {
    height: 30px !important;
    line-height: 30px !important;
}

</style>
